import { createContext } from 'react';
import { IApplicationData } from '../interfaces';

export const ApplicationContext = createContext<IApplicationData | undefined>(undefined);
